import { Component, createElement } from 'react';
import { Space, Button } from 'antd';
import { uuid } from '../index';
export class BaseDialog extends Component {
    state = {
        open: this.props?.open ?? false
    };
    open() {
        return new Promise((resolve) => {
            this.setState({
                open: true
            }, () => {
                resolve(null);
            });
        });
    }
    show() {
        this.open();
    }
    hide() {
        return new Promise((resolve) => {
            this.setState({
                open: false
            }, () => {
                resolve(null);
            });
        });
    }
    hidden() {
        return this.hide();
    }
    transformProps() {
        const onCancel = (e) => {
            this.props?.onCancel?.(e);
            this.props?.onClose?.(e);
            this.hide();
        };
        const innerProps = {
            open: this.state.open,
            footer: this.props?.footer,
            onCancel,
            footerStyle: { textAlign: 'right' }
        };
        if (this.props.__designMode === 'design') {
            innerProps.open = true;
        }
        const getActionHandler = (item) => {
            switch (item?.action) {
                case 'submit':
                    return this.props?.onOk;
                case 'cancel':
                    return onCancel;
                default:
                    if (item.callback) {
                        return item.callback;
                    }
                    else {
                        return () => { };
                    }
            }
        };
        if (!this.props?.operations || this.props?.operations?.length === 0) {
            innerProps.footer = null;
        }
        else {
            innerProps.footer = (createElement(Space, null, this.props?.operations?.map((item) => {
                return (createElement(Button, { key: uuid(), type: item?.type, onClick: getActionHandler(item) }, item?.content ?? '自定义'));
            })));
        }
        return innerProps;
    }
}
